import React, { Component } from 'react';
import './portfolio.scss';
import PortfolioCard from '../../components/portfolio-card/portfolio-card';

class Portfolio extends Component {

  componentDidMount() {
    window.scrollTo(0, 0);
  }

  render() {
    return (
      <div className="portfolio">
        <div className="header">
          <div className="title-container">
            <h1 className="title" data-aos="fade-down" data-aos-duration="1000">We take our work seriously!</h1>
            <h3 className="subtitle" data-aos="fade-up" data-aos-delay="1000" data-aos-duration="1000">We showcase our best work to give you a preview of what we deliver and how we deliver it.</h3>
          </div>
        </div>
        <div className="portfolio-cards">
          <PortfolioCard
            imgsrc={require('./ilovenorrislake/ilovenorrislake.png')}
            cardTitle="Tennessee Home Finders"
            cardText="Tennessee Home Finders is a real estate company that requested a website tailored just for them.
            Using an MLS API, we are able to pull data directly from the realtor MLS and display it on their custom website.
            This site gives users the ability to search for homes conveniently displayed as a list or as a map of their area!
            We developed this site entirely on Django with a PostgresSQL backend, which we host for the client in AWS."
            images={[
              require('./ilovenorrislake/ilovenorrislake.png'),
              require('./ilovenorrislake/home.png'),
              require('./ilovenorrislake/homesearch.png'),
              require('./ilovenorrislake/mapsearch.png'),
              require('./ilovenorrislake/homedesc.png'),
            ]}
          />
          <PortfolioCard
            imgsrc={require('./kraftconstruction/kraftconstructionco.png')}
            cardTitle="Kraft Construction Co."
            cardText="Kraft Construction Co. is a home remodeling company located in Cincinnati, Ohio.
            The owners came to us looking to update their website in hopes of boosting their online presence.
            Our creative team developed a modern website with impressive designs using Wordpress.
            Even now that the website is functional, we continue to help by hosting the website on AWS and closely monitoring the server to ensure that it is always running efficiently."
            images={[
              require('./kraftconstruction/kraftconstructionco.png'),
              require('./kraftconstruction/home.png'),
              require('./kraftconstruction/login.png'),
              require('./kraftconstruction/testimonials.png'),
            ]}
          />
          <PortfolioCard
            imgsrc={require('./tfsinspection/tfs-inspection.png')}
            cardTitle="Total Fleet Solutions"
            cardText="Total Fleet Solutions was looking to build an app to inspect material handling equipment.
            They contacted us to make the app and needed it to sync to their existing CRM.
            Using Xcode and Swift we were able to develop a state of the art mobile application meeting all of their needs.
            The data is stored on their cloud CRM where they are able to analyze the data to support their customers."
            images={[
              require('./tfsinspection/tfs-inspection.png'),
              require('./tfsinspection/home.png'),
              require('./tfsinspection/info.png'),
              require('./tfsinspection/location.png'),
            ]}
          />
          <PortfolioCard
            imgsrc={require('./lotterfree/lotterfree.png')}
            cardTitle="Lotterfree"
            cardText="Lotterfree was a web and mobile application designed to bring the lottery to the masses without the need to pay.
            It allowed users to earn entries into the lottery by simply watching advertisements and then a random winner was selected every day.
            Because of the money at stake, we worked to make sure the system was absolutely bulletproof and in line with any platform's policies.
            The apps were made natively with Java and Swift and the web app was made using PHP.
            We built the backend using Node.js hosted on Microsoft Azure."
            images={[
              require('./lotterfree/lotterfree.png'),
              require('./lotterfree/login.png'),
              require('./lotterfree/main.png'),
              require('./lotterfree/menu.png'),
            ]}
          />
          <PortfolioCard
            imgsrc={require('./merakimap/meraki-map.png')}
            cardTitle="Network Map"
            cardText="Our client came to us seeking one convenient way to display the statuses of the networks for each of their locations across the country.
            The client is using Cisco Meraki and we were able to tap into the Meraki API and build a real-time network map.
            Its simple design signals when a network goes down and provides a diagnosis of the issue to ensure prompt action is taken to resolve it.
            The map is built using Mapbox, React, and NodeJS and is hosted on the customers own AWS Cloud Platform where we deployed it using Ubuntu and Nginx."
            images={[
              require('./merakimap/meraki-map.png'),
              require('./merakimap/main.png'),
              require('./merakimap/downstatus.png'),
              require('./merakimap/zoomed.png'),
            ]}
          />
          <PortfolioCard
            imgsrc={require('./mnsmap/mns-affiliate-map.png')}
            cardTitle="Miner National Services"
            cardText="Miner National Services dispatches affiliate companies to complete work on their behalf.
            They neither knew which areas their affliates serviced nor which services were performed at each location without spending excessive time researching.
            We have maximized the efficiency of their company by compiling the data into one convenient platform that allows them to find the information in a timely manner.
            The site is writen in C#, hosted on AWS, and ties directly into our customer's cloud CRM."
            images={[
              require('./mnsmap/mns-affiliate-map.png'),
              require('./mnsmap/main.png'),
              require('./mnsmap/zoomed.png'),
              require('./mnsmap/success.png'),
            ]}
          />
          <PortfolioCard
            imgsrc={require('./classvalet/classvalet.png')}
            cardTitle="Class Valet"
            cardText="Class Valet is a platform designed to help teachers manage their classrooms more efficiently.
            Our client originally used spreadsheets to keep track of all information and wanted things to be in one easy-to-use platform.
            With organization in mind, we developed the site with a Django backend that allows the teachers to manage their data easily.
            We used a PostgresSQL database to store everything and used some key gen that gives users the capability to join the same teams."
            images={[
              require('./classvalet/classvalet.png'),
              require('./classvalet/home.png'),
              require('./classvalet/login.png'),
              require('./classvalet/dashboard.png'),
              require('./classvalet/settings.png'),
            ]}
          />
          <PortfolioCard
            imgsrc={require('./brownbutton/brownbutton.png')}
            cardTitle="Brownbutton"
            cardText="Brownbutton is an estate sale company that wanted to go digital.
            They initially had an app made in Google Appsheet which did the job but was horrendously slow.
            They contacted us needing help converting their Appsheet app into a real app as well as adding some features.
            This is a true Progressive Web App, meaning it works similarly to a native app but runs on the web.
            We used the latest technologies for this including Ionic 2 which is built on top of Angular 2 as well as a Django backend converted to an API."
            images={[
              require('./brownbutton/brownbutton.png'),
              require('./brownbutton/home.png'),
              require('./brownbutton/pickups.png'),
              require('./brownbutton/teamfiles.png'),
            ]}
          />
          <PortfolioCard
            imgsrc={require('./assetperiscope/assetperiscope.png')}
            cardTitle="Asset Periscope"
            cardText="Asset Periscope was designed to help users track their assets.
            Notifications are baked in to help understand if an asset will be over- or under-utilized and when the asset will be coming off term.
            We utilized Amazon Web Services for data storage, file storage, and user authentication.
            The site was developed using ASP.NET with the idea in mind to create a mobile application in the future."
            images={[
              require('./assetperiscope/assetperiscope.png'),
              require('./assetperiscope/dashboard.png'),
              require('./assetperiscope/selectplan.png'),
              require('./assetperiscope/editasset.png'),
              require('./assetperiscope/map.png'),
            ]}
          />
        </div>
      </div>
    );
  }
}

export default Portfolio;


// WEBPACK FOOTER //
// ./src/pages/portfolio/portfolio.js